module.exports = __webpack_public_path__ + "img/Logo.71915d8a.jpg";